<template>
    <transition name="fade">
        <div class="modal" :class="{'show':modal_show}" tabindex="-1" aria-hidden="true" v-if="modal_show">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Confirmation</h5>
                        <button type="button" class="btn btn-round close" @click="close">
                            <i class="mdi mdi-close"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="fw-600 px-2">Do you want to delete this item ?</p>

                        <div class="d-flex flex-row justify-content-end">
                            <button type="button" class="btn fw-600 text-primary" @click="deleteTrigger">Delete</button>
                            <button type="button" class="btn fw-600" @click="close">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
            modal_show: false,
            callback: {},
            id: ''
        }
    },
    methods: {
        close() {
            this.modal_show = false;
            this.callback = {};
            this.id = '';
        },
        deleteTrigger() {
            this.callback(this.id);
            this.close();
        }
    },
    mounted() {
        this.$emitter.on('delete_modal_show', (data) => {
            this.modal_show = true;
            if(typeof data[0] == 'function') {
                this.callback = data[0];
                this.id = data[1];
            }
        });
    }
}
</script>

<style scoped>
.modal::after {
    background: #000;
    content: '';
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: -1;
    opacity: 0.5;
}

.modal.show {
    display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


.text-primary {
    color: var(--primary-color) !important;
}
</style>